import { create, clickable, fillable, isPresent, text, value, visitable } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default create({
  visit: visitable('/private/registries/:registry/boxes/:box/versions/:version/edit'),
  title: text('[data-test-title]'),
  subtitle: text('[data-test-subtitle]'),
  name: value('[data-test-name]'),
  architectureType: value('select[name="architectureType"]'),
  checksum: value('[data-test-checksum]'),
  checksumType: value('[data-test-checksum-type]'),
  externalUrl: value('[data-test-external-url]'),
  hasExternalUrl: isPresent('[data-test-external-url]'),
  selectArchitectureType: fillable('select[name="architectureType"]'),
  fillInChecksum: fillable('[data-test-checksum]'),
  selectChecksumType: fillable('[data-test-checksum-type]'),
  fillInExternalUrl: fillable('[data-test-external-url]'),
  update: clickable('[data-test-update]'),
  flash: flashMessage
});